import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
export const CheckboxInput = ({
  disabled,
  id,
  label,
  onChange,
  readOnly,
  value,
  autoFocus,
  required
}) => {
  const inputProps = {
    'aria-label': label,
    disabled,
    id,
    onChange: event => onChange(event.target.checked),
    readOnly,
    value,
    autoFocus,
    required
  };
  return /*#__PURE__*/_jsx(Checkbox, Object.assign({
    tabIndex: 0
  }, inputProps));
};